export const getFundTypeName = (fundType, translations) => {
    switch (fundType) {
        case 'EQUITY':
            return translations.equity;
        case 'FIXED_INCOME':
            return translations.fixedIncome;
        case 'BALANCED':
            return translations.balanced;
        case 'ALTERNATIVE':
            return translations.alternative;
        case 'INDEX':
            return translations.index;
        case 'UNKNOWN':
        default:
            return undefined;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWZ1bmQtdHlwZS1uYW1lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2FwcHMvZnVuZC1saXN0L3V0aWxzL2dldC1mdW5kLXR5cGUtbmFtZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsQ0FBQyxRQUFvQyxFQUFFLFlBQWlDLEVBQUUsRUFBRTtJQUN2RyxRQUFRLFFBQVEsRUFBRSxDQUFDO1FBQ2YsS0FBSyxRQUFRO1lBQ1QsT0FBTyxZQUFZLENBQUMsTUFBTSxDQUFDO1FBQy9CLEtBQUssY0FBYztZQUNmLE9BQU8sWUFBWSxDQUFDLFdBQVcsQ0FBQztRQUNwQyxLQUFLLFVBQVU7WUFDWCxPQUFPLFlBQVksQ0FBQyxRQUFRLENBQUM7UUFDakMsS0FBSyxhQUFhO1lBQ2QsT0FBTyxZQUFZLENBQUMsV0FBVyxDQUFDO1FBQ3BDLEtBQUssT0FBTztZQUNSLE9BQU8sWUFBWSxDQUFDLEtBQUssQ0FBQztRQUM5QixLQUFLLFNBQVMsQ0FBQztRQUNmO1lBQ0ksT0FBTyxTQUFTLENBQUM7SUFDekIsQ0FBQztBQUNMLENBQUMsQ0FBQyJ9